<template>
    <div>
        <card-header title="Resellers" icon="fa-user-tie"/>

        <card-body>
            <card-list>
                <subheader-list-item title="Reseller Users" icon="fa-user-tie" :badge="resellers.length"/>
                <user-tile
                    v-for="user in resellers"
                    :card="card"
                    :user="user"
                    :active="(child && child.definition.component === 'user' && user.id === parseInt(child.props.userId))"
                    @click="$openCard('user', {userId: user.id}, card)"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";

    import UserTile from "../../components/tiles/UserTile";
    import {client as http} from '@/http_client';

    import ContainerListItem from "../../TIER/components/ContainerListItem";

    export default {
        components: {ContainerListItem, CardHeader, CardBody, CardList, UserTile, SubheaderListItem},
        props: ['card', 'child'],

        data() {
            return {
                resellers: []
            };
        },
        methods: {
            loadUsers: function(forced) {
                this.$emit('loading', true);

                http.get('users/resellers/0/30', {force: forced}).then(response => {
                    this.resellers = response.data;
                    this.$emit('loading', false);

                });
            }
        },

        mounted: function() {
            this.loadUsers();
        }
    };
</script>
